export default __webpack_public_path__ + "cf1d221a426bc285fd18e5ee9f522bf5.png";